export const common = {
  accessTokenKey: 'slack_access_token',
  defaultKudosAmount: 50
}
